require('./template.js');

Pegasus.CaptureTemplate = Pegasus.Template.extend({
  fragments: [],
  underscore_type: 'capture_template',
  globalSettings: DS.attr('string'),
  html: DS.attr('string'),
  openingHtmlPart: DS.attr('string'),
  userDefinedBackgroundImage: null,
  userDefinedBackgroundColor: null,
  paletteType: 'CapturePalette',
  bodyImageType: 'CaptureTemplateBodyImage',
  blockRegionImageType: 'CaptureTemplateBlockRegionImage',
  supportsRowColorOpacity: true,
  previewContent: function(_,value){
    if( typeof( value ) !== 'undefined' ){
      return value;
    }
    return '';
  }.property(),
  gallerySizeKey: 'landscape',
  insideHtmlPart: DS.attr('string'),
  uid: DS.attr('string'),
  maxImageWidth: 1200,
  maxContentWidth: 1024, // this is kind of strange but we use this value to calculate other things
  minContentWidth: 240,
  minContentHeight: 70
});

Pegasus.CaptureTemplate.FIXTURES = [];
Pegasus.CaptureTemplate.reopen({
  createFromExternal: function(){
    return {
      data: {
        selectedTheme: {
          name: 'themecapture1'
        }
      },
      model: this.store.createRecord(Pegasus.CaptureTemplate)
    };
  }
});
